
import SideNav from '@/components/SideNav/SideNav'
// import AppState from '@/components/AppState/AppState'
import Launcher from '@/components/Launcher/Launcher.vue'
// import AppState from '@/components/AppState/AppState'
export default {
  components: {
    SideNav,
    // AppState,
    Launcher
  }
}
